module.exports = __webpack_public_path__ + "img/right-angle.46a49b3d.svg";